module.exports = __webpack_public_path__ + "static/media/binggrae-strawberry.2dac0478.jpg";